document.addEventListener('DOMContentLoaded', () => {
  // Läuft nur, wenn die FAQ-Search-Sektion da ist
  const faqPage = document.querySelector('.faq-page');
  if (!faqPage) return;

  const searchInput = faqPage.querySelector('#faq-search');
  if (!searchInput) return;

  // Alle FAQ-Items unterhalb der Suche
  const faqItems = Array.from(
    document.querySelectorAll('.accordion, details, .collapsible-content__row')
  );

  const normalize = (str) =>
    (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  searchInput.addEventListener('input', () => {
    const query = normalize(searchInput.value.trim());

    faqItems.forEach(item => {
      const text = normalize(item.textContent);
      item.style.display = text.includes(query) ? '' : 'none';
    });
  });
});
